import type { MopsUserInteraction } from "../marops-types";
import { REGEX_DEV_ENDPOINT } from "../constants";

const ls = window.localStorage;
const ss = window.sessionStorage;

const utmCampaign = (searchParams: URLSearchParams) => {
  return searchParams.get('utm_campaign') || ls.getItem('utm_campaign') || ''
};

const utmSource = (searchParams: URLSearchParams) => {
  return searchParams.get('utm_source') || ls.getItem('utm_source') || ''
};

const utmMedium = (searchParams: URLSearchParams) => {
  return searchParams.get('utm_medium') || ls.getItem('utm_medium') || ''
};

const utmContent = (searchParams: URLSearchParams) => {
  return searchParams.get('utm_content') || ls.getItem('utm_content') || ''
};

const utmTerm = (searchParams: URLSearchParams) => {
  return searchParams.get('utm_term') || ls.getItem('utm_term') || ''
};

const partnerToken = (searchParams: URLSearchParams) => {
  return searchParams.get('partner') || ss.getItem('partner') || ss.getItem('partner_token') || '';
};

const salesRepToken = (searchParams: URLSearchParams) => {
  return searchParams.get('rep') || ss.getItem('sales_rep') || ss.getItem('rep') || '';
};

const abVariant = () => {
  return REGEX_DEV_ENDPOINT.test(window.location.hostname) ? 'development' : 'production';
}

export const mopsFormEvent = (eventName: string, data: Record<string, any>): MopsUserInteraction => {
  const searchParams = new URLSearchParams(window.location.search);
  const orientation  = (window.screen ? window.screen.width >= window.screen.height ? 'landscape' : 'portrait' : '');
  const screenWidth  = (window.screen ? window.screen.width : 0)
  const screenHeight = (window.screen ? window.screen.height : 0);
  const colorDepth   = (window.screen ? window.screen.colorDepth : 0)
  const interaction: MopsUserInteraction = {
    event_name: eventName,
    timestamp: Date.now(),
    domain_name: window.location.hostname,
    page_path: window.location.pathname,
    formId: data.formId || '',
    referrer: document.referrer || 'direct',
    ab_variant: ls.getItem('ab_variant') || abVariant(),
    mops_xid: ls.getItem('mops_xid') || '',
    error: data.error || '',
    reference_number: data.form_request_id || '',
    utm_campaign: utmCampaign(searchParams),
    utm_source: utmSource(searchParams),
    utm_medium: utmMedium(searchParams),
    utm_content: utmContent(searchParams),
    utm_term: utmTerm(searchParams),
    partner: partnerToken(searchParams),
    sales_rep: salesRepToken(searchParams),
    screen_width: screenWidth,
    screen_height: screenHeight,
    screen_color_depth: colorDepth,
    screen_orientation: orientation,
    google_click_id: ss.getItem('google_click_id') || '',
    microsoft_click_id: ss.getItem('microsoft_click_id') || '',
    linkedin_click_id: ss.getItem('linkedin_click_id') || '',
    facebook_click_id: ss.getItem('facebook_click_id') || '',
    gpc_pref: ls.getItem('gpc_pref') || "0",
    dnt_pref: ls.getItem('dnt_pref') || "0",
  };
  return interaction;
}
